// extracted by mini-css-extract-plugin
export default {"notification":"kOC9s","notification-wrapper":"_1SuY3","notificationWrapper":"_1SuY3","tooltip":"_2Fc0j","new-tooltip":"_1C0Jh","newTooltip":"_1C0Jh"};